import template from './company_goals_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class CompanyGoalsHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class CompanyGoalsHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new CompanyGoalsHelpViewModel(this);
		this.bindings = bindings;
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'CompanyGoalsHelp',
	dialog_class: CompanyGoalsHelpPage,
	template: template,
	template_filename: 'translation/dialogs/company_goals_help',
	provider: 'ps'
};